/* eslint-disable @typescript-eslint/no-non-null-assertion */
export const config = {
  organization_id: process.env.REACT_APP_ORGANIZATION_ID || 'dentistry-one',
  division_id: process.env.REACT_APP_DIVISION_ID,
  practice_id: process.env.REACT_APP_PRACTICE_ID,
  domain_name: process.env.REACT_APP_COOKIE_DOMAIN_NAME || '.dentistry.one',
  cookie_secure: process.env.REACT_APP_COOKIE_SECURE !== 'false' && process.env.REACT_APP_SECURE_COOKIES !== 'false',
  api: {
    baseUrl: process.env.REACT_APP_DENTISTRY_ONE_API_URL || 'https://develop-api.dentistry.one',
    googleAPI: process.env.REACT_APP_GOOGLE_API || 'AIzaSyCuTJG59A-p6p3MUr_d9swbytRJ0tnamiM',
  },
  iot: {
    prefix: process.env.REACT_APP_IOT_PREFIX || 'develop',
    reconnectPeriod: parseInt(process.env.REACT_APP_IOT_RECONNECT_PERIOD || '10000', 10),
  },
  square: {
    src: process.env.REACT_APP_SQUARE_SRC || 'https://sandbox.web.squarecdn.com/v1/square.js',
    applicationId: process.env.REACT_APP_SQUARE_APPLICATION_ID!,
    locationId: process.env.REACT_APP_SQUARE_LOCATION_ID!,
  },
  ga: {
    trackingId: process.env.REACT_APP_GA_TRACKING_ID || null,
  },
  organization: {
    name: process.env.REACT_APP_APP_BRAND || 'default',
  },
  features: {
    multiStage: process.env.REACT_APP_FEATURE_MULTI_STAGE === 'true',
    // Passkey and passwordless sign-in are not cleared to go live yet, so they
    // default to off (hidden). Set the env var to 'true' to re-enable per brand.
    passkey: process.env.REACT_APP_FEATURE_PASSKEY === 'true',
    passwordless: process.env.REACT_APP_FEATURE_PASSWORDLESS === 'true',
  },
  excludedCioClientTags: ['mainely-connection'],
  excludedCioOrganizations: ['mainely-connection'],
};
